
import { Base } from './base.model';
import { Perfil } from 'src/app/security/entidades/perfil';
import { Sucursal } from '../general/sucursal.model';

export class Usuario extends Base{
  public id: number;
  public usuario: string;
  public password: string;
  public ultimoIntento: Date;
  public intentos: number;
  public perfil: Perfil;
  public nombre: string;
  public apellidoPaterno: string;
  public apellidoMaterno: string;
  public correo: string;
  public user_nom: string;
  public idPerfil: number;
  public idSucursal: number;
  public estatus: number;
  public sucursal: Sucursal;
  public multiSucursal: number;
  public nombreContrato:string;

  constructor(user_nom: string, password: string) {
    super();
    this.usuario = user_nom;
    this.password = password;
    this.estatus = 0;
  }
  
}
